import has from 'lodash/has'
import set from 'lodash/set'

import * as PoziUtils from 'api/utils'
import GetPropertiesIdKey from 'data/GetPropertiesIdKey'
import { setLayerId } from 'drawer/tabs/layers/actions'

export default function (geojson, layerConf) {
  const features = geojson?.features || []
  if (!features || features.length === 0) {
    console.log('AddId - GeoJSON contains no features', geojson)
    return
  }

  if (!layerConf) {
    console.log('AddId - No layer config provided')
    return
  }

  const titleid = layerConf?.titleid
  if (!titleid) {
    console.log('AddId - No title id found in layer config', layerConf)
    return
  }

  // Check if ID field actually exists in feature properties.
  // If it is the special field '$id', we will accept that as valid.
  let id = layerConf?.config?.spatial?.id

  const firstFeatureProps = features[0]?.properties || {}
  const idIsValid = (id === '$id') || (id && !!PoziUtils.findPropName(firstFeatureProps, id))
  if (!idIsValid) {
    if (id) {
      console.warn(`AddId - Invalid ID ('${id}') set in 'config.spatial.id' of '${titleid}'. This needs to be fixed!`)
    } else {
      console.debug(`AddId - ID has not been set for layer '${titleid}'`, id)
    }

    // console.debug('AddId - Will attempt to determine ID from data...')

    // Try to determine a suitable ID and default to '$id' if nothing is found
    id = GetPropertiesIdKey(layerConf, firstFeatureProps) || '$id'

    // console.debug('AddId - Found/created new ID and storing in layer config: ', titleid, id)

    // Set ID in redux store
    window.store.dispatch(setLayerId(titleid, id))

    // Set ID in app.layerConfig as well
    // (used in selectVectorFeatureFromIDTextAndLayerConfig in api/utils)
    const app = PoziUtils.getApp()
    const title = layerConf.title
    set(app, `layerConfig[${title}].config.config.spatial.id`, id)
  }

  // Generate ID value for every feature if ID field is called '$id'
  if (id === '$id') {
    for (const featurekey in geojson.features) {
      const feature = geojson.features[featurekey]

      if (!has(feature, 'properties.$id')) {
        set(feature, 'properties.$id', featurekey)
      }
    }
  }
}
